import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";

const style = () => {
  const { borderRadius4, colorBgBase, colorBgPrimaryLight, space4, space6, space12, colorTextMedium } = theme();

  return StyleSheet.create({
    actions: {
      alignSelf: "center",
      width: "100%",
    },
    actionsLarge: {
      backgroundColor: colorBgBase,
      borderRadius: borderRadius4,
    },
    actionsSmall: {
      padding: space6,
    },
    bodyText: {
      color: colorTextMedium,
      marginBottom: space6,
      marginTop: space4,
    },
    bodyTextSecondary: {
      color: colorTextMedium,
      marginBottom: space4,
    },
    button: {
      alignSelf: "stretch",
    },
    content: {
      alignSelf: "center",
    },
    contentLarge: {
      backgroundColor: colorBgBase,
      borderRadius: borderRadius4,
      paddingHorizontal: space6,
      paddingVertical: space12,
    },
    contentSmall: {
      flex: 1,
      justifyContent: "space-between",
    },
    contentWrapper: {
      display: "flex",
      flex: 1,
      justifyContent: "center",
      marginHorizontal: "auto",
    },
    goHome: {
      marginBottom: space6,
    },
    infoSmall: {
      flex: 1,
      justifyContent: "center",
      padding: space6,
    },
    instructions: {
      marginBottom: space4,
      marginTop: space6,
    },
    instructionsSmall: {
      marginBottom: space4,
    },
    text: {
      marginBottom: space6,
    },
    title: {
      marginBottom: space4,
    },
    wrapper: {
      flexGrow: 1,
    },
    wrapperLarge: {
      backgroundColor: colorBgPrimaryLight,
    },
    wrapperSmall: {
      justifyContent: "flex-start",
    },
  });
};

export { style };
